import { getSearchString } from '@src/utils/query-string';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const AppLink = (props: Props) => {
    const { href, ...rest } = props;
    const router = useRouter();
    const hrefWithParams = useMemo(() => {
        return `${href}${getSearchString()}`;
    }, [href]);
    return (
        <a
            {...rest}
            onClick={() => {
                router.push(hrefWithParams);
            }}
        ></a>
    );
};
